import { Component, Input, ContentChild, OnInit, AfterContentInit, HostBinding } from '@angular/core';
import { InputRefDirective } from '../common/input-ref.directive';

@Component({
  selector: 'icon-input',
  templateUrl: './icon-input.component.html',
  styleUrls: ['./icon-input.component.scss']
})
export class IconInputComponent implements OnInit, AfterContentInit {

  @Input()
  img: string;

  @ContentChild(InputRefDirective, { static: false })
  input: InputRefDirective;

  constructor() { }

  ngOnInit() {
  }

  ngAfterContentInit() {
    if (!this.input) {
      console.error('The icon-input needs an input tag inside its content');
    }
  }

  @HostBinding('class.input-focus')
  get isInputFocus() {
    return this.input ? this.input.focus : false;
  }
}
